"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEventName = void 0;
var GlobalEventName;
(function (GlobalEventName) {
    GlobalEventName["GLOBAL_DUST_STORM"] = "Global Dust Storm";
    GlobalEventName["SPONSORED_PROJECTS"] = "Sponsored Projects";
    GlobalEventName["ASTEROID_MINING"] = "Asteroid Mining";
    GlobalEventName["GENEROUS_FUNDING"] = "Generous Funding";
    GlobalEventName["SUCCESSFUL_ORGANISMS"] = "Successful Organisms";
    GlobalEventName["ECO_SABOTAGE"] = "Eco Sabotage";
    GlobalEventName["PRODUCTIVITY"] = "Productivity";
    GlobalEventName["SNOW_COVER"] = "Snow Cover";
    GlobalEventName["DIVERSITY"] = "Diversity";
    GlobalEventName["PANDEMIC"] = "Pandemic";
    GlobalEventName["WAR_ON_EARTH"] = "War on Earth";
    GlobalEventName["IMPROVED_ENERGY_TEMPLATES"] = "Improved Energy Templates";
    GlobalEventName["INTERPLANETARY_TRADE"] = "Interplanetary Trade";
    GlobalEventName["CELEBRITY_LEADERS"] = "Celebrity Leaders";
    GlobalEventName["SPINOFF_PRODUCTS"] = "Spin-Off Products";
    GlobalEventName["ELECTION"] = "Election";
    GlobalEventName["AQUIFER_RELEASED_BY_PUBLIC_COUNCIL"] = "Aquifer Released by Public Council";
    GlobalEventName["PARADIGM_BREAKDOWN"] = "Paradigm Breakdown";
    GlobalEventName["HOMEWORLD_SUPPORT"] = "Homeworld Support";
    GlobalEventName["RIOTS"] = "Riots";
    GlobalEventName["VOLCANIC_ERUPTIONS"] = "Volcanic Eruptions";
    GlobalEventName["MUD_SLIDES"] = "Mud Slides";
    GlobalEventName["MINERS_ON_STRIKE"] = "Miners On Strike";
    GlobalEventName["SABOTAGE"] = "Sabotage";
    GlobalEventName["REVOLUTION"] = "Revolution";
    GlobalEventName["DRY_DESERTS"] = "Dry Deserts";
    GlobalEventName["SCIENTIFIC_COMMUNITY"] = "Scientific Community";
    GlobalEventName["CORROSIVE_RAIN"] = "Corrosive Rain";
    GlobalEventName["JOVIAN_TAX_RIGHTS"] = "Jovian Tax Rights";
    GlobalEventName["RED_INFLUENCE"] = "Red Influence";
    GlobalEventName["SOLARNET_SHUTDOWN"] = "Solarnet Shutdown";
    GlobalEventName["STRONG_SOCIETY"] = "Strong Society";
    GlobalEventName["SOLAR_FLARE"] = "Solar Flare";
    GlobalEventName["VENUS_INFRASTRUCTURE"] = "Venus Infrastructure";
    GlobalEventName["CLOUD_SOCIETIES"] = "Cloud Societies";
    GlobalEventName["MICROGRAVITY_HEALTH_PROBLEMS"] = "Microgravity Health Problems";
    GlobalEventName["LEADERSHIP_SUMMIT"] = "Leadership Summit";
    GlobalEventName["GLOBAL_DUST_STORM_REBALANCED"] = "Global Dust Storm(\u2696)";
    GlobalEventName["CORROSIVE_RAIN_REBALANCED"] = "Corrosive Rain(\u2696)";
    GlobalEventName["ECO_SABOTAGE_REBALANCED"] = "Eco Sabotage(\u2696)";
    GlobalEventName["SCIENTIFIC_COMMUNITY_REBALANCED"] = "Scientific Community(\u2696)";
    GlobalEventName["HEATED_DISCUSSIONS"] = "Heated Discussions";
    GlobalEventName["SEALOCKED_HOLMES"] = "Sealocked Holmes";
})(GlobalEventName = exports.GlobalEventName || (exports.GlobalEventName = {}));
//# sourceMappingURL=GlobalEventName.js.map